import logo from './logo.svg';
import React, { useState,useContext,useEffect } from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Link, Route,Redirect,Navigate,useNavigate } from 'react-router-dom';
// import MyProvider from './contextapi/MyProvider';
import Authlayout from './layouts/authlayout';
import Dashboardlayout from './layouts/dashboardlayout';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Users from './pages/users';
import Reports from './pages/reports';
import Rdsreports from './pages/rdsreport';
import Admin from './pages/admin';
import Approver from './pages/approver';
import MultiApprover from './pages/multiapprover';
import Timesheetadmin from './pages/timesheetadmin';
import Timesheetapproveadmin from './pages/timesheetapproveadmin';
import FinalbillReports from './pages/finalbillreports';
import ProductivityReports from './pages/productivityreport';
import Finalbillconfig from './pages/finalbillconfig';
import Bookkeepingbill from './pages/bookkeepingbill';
import Targethourstemplates from './pages/targethr_template';
import BillingReports from './pages/billingreports';
import Finalbillapproval from './pages/finalbillapproval';
import Resetpassword from './pages/resetpassword';
import Forgotpassword from './pages/forgotpassword';
import FinalbillDelete from './pages/finalbilldeletion';
import Holidays from './pages/holidays';
import NotFound from './pages/notfoundpage';

import MyContext from "./contextapi/MyContext";

import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import axios from 'axios';
const allowedRoutes = ['/dashboard', '/admin'];

function App() {
  const mycontext = useContext(MyContext);
  const authtoken = localStorage.getItem('authtoken');

  const roledata = localStorage.getItem('role') != '' && localStorage.getItem('role') != 'null' ? JSON.parse(localStorage.getItem('role')) : {};
  console.log(authtoken);
  if(authtoken != '' && authtoken != undefined && authtoken != null){
     mycontext.updateuserloggedinstatus(true);
  }else{
     mycontext.updateuserloggedinstatus(false);
  }

  const autoauthchecker = () =>{
    axios.interceptors.response.use(response => {
      // Modify response data
      // console.log('auth checker');
      // console.log(response);
      return response;
    }, error => {
      console.log("auth cheker error");
      console.log(error.response.status);
      if(error.response.status == 401){
        // logout 
        localStorage.clear();
        mycontext.updateuserloggedinstatus(false);
        window.location.href='/';
      }
      // Handle response error
      return Promise.reject(error);
    });  
 } 
 autoauthchecker();
 const isloggedin = mycontext.isloggedin;

  return (
    // <MyProvider>
    <PrimeReactProvider>
      <div className="App">
        <Router>
          <Routes>
            {/* Auth */}
            {!isloggedin ? (
              <>
              <Route
                path="/"
                element={
                  <Authlayout>
                    <Login />
                  </Authlayout>
                }
              />
              <Route 
                   path="/forgotpassword"
                   element={
                     <Authlayout>
                       <Forgotpassword/>
                     </Authlayout>
                   }
               />
              <Route path="*" element={<NotFound/>} />
              </>
            ) : (
              <>
                <Route
                  path="/"
                  element={
                    <Dashboardlayout>
                      <Dashboard />
                    </Dashboardlayout>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <Dashboardlayout>
                      <Dashboard />
                    </Dashboardlayout>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <Dashboardlayout>
                      <Users />
                    </Dashboardlayout>
                  }
                />

                <Route
                  path="/showreport"
                  element={
                    <Dashboardlayout>
                      <Reports />
                    </Dashboardlayout>
                  }
                />

                <Route
                  path="/rdsrepport"
                  element={
                    <Dashboardlayout>
                      <Rdsreports />
                    </Dashboardlayout>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <Dashboardlayout>
                      <Admin />
                    </Dashboardlayout>
                  }
                />
                <Route
                  path="/approver"
                  element={
                    <Dashboardlayout>
                      <Approver />
                    </Dashboardlayout>
                  }
                />

                <Route
                  path="/tmsapptms"
                  element={
                    <Dashboardlayout>
                      <Timesheetadmin />
                    </Dashboardlayout>
                  }
                />
                <Route
                  path="/tmsapprovetms"
                  element={
                    <Dashboardlayout>
                      <Timesheetapproveadmin />
                    </Dashboardlayout>
                  }
                />
               <Route
                  path="/finalbillingreport"
                  element={
                    <Dashboardlayout>
                      <FinalbillReports />
                    </Dashboardlayout>
                  }
                />

                <Route
                  path="/finalbilling"
                  element={
                    <Dashboardlayout>
                      <Finalbillconfig />
                    </Dashboardlayout>
                  }
                />

                <Route
                  path="/finalbilldeletion"
                  element={
                    <Dashboardlayout>
                      <FinalbillDelete  tabname={'FinalBill delete'}/>
                    </Dashboardlayout>
                  }
                />



               <Route
                  path="/budgetreport"
                  element={
                    <Dashboardlayout>
                      <ProductivityReports />
                    </Dashboardlayout>
                  }
                /> 
               
               <Route 
                   path="/Bkfinalbillingreport"
                   element={
                     <Dashboardlayout>
                       <Bookkeepingbill/>
                     </Dashboardlayout>
                   }
               /> 

              <Route 
                   path="/targethr_template"
                   element={
                     <Dashboardlayout>
                       <Targethourstemplates/>
                     </Dashboardlayout>
                   }
               />

               <Route 
                   path="/allbilling_report"
                   element={
                     <Dashboardlayout>
                       <BillingReports/>
                     </Dashboardlayout>
                   }
               />


                <Route 
                   path="/holidays"
                   element={
                     <Dashboardlayout>
                       <Holidays tabname={'Holidays'}/>
                     </Dashboardlayout>
                   }
               />



              {(roledata.rolename == 'superadmin' || roledata.rolename == 'admin') ? (<Route 
                   path="/finalbillapproval"
                   element={
                     <Dashboardlayout>
                       <Finalbillapproval/>
                     </Dashboardlayout>
                   }
               />) : (<></>)}
              

               <Route 
                   path="/resetpassword"
                   element={
                     <Dashboardlayout>
                       <Resetpassword/>
                     </Dashboardlayout>
                   }
               />

                 
                <Route path="*" element={<NotFound/>} />
              </>
            )}
          </Routes>

          {/* Conditional Redirects */}
          {/* {isloggedin ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Navigate to="/" replace />
          )} */}
        </Router>
      </div>
      </PrimeReactProvider>
    // </MyProvider>
  );
}

export default App;
